import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import './assets/user-style.css';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'font-awesome/css/font-awesome.min.css' // TODO remove from all website
import 'material-design-icons/iconfont/material-icons.css' // TODO use this icon instead
import 'vue-snack/dist/vue-snack.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'video.js/src/css/video-js.scss'
import 'video.js/src/css/vjs.scss'
import './assets/vjs-netflix-skin.scss'
import './assets/style.css' // TODO remove this css file
import 'toastr/build/toastr.min.css'
import './assets/style.scss' // global CSS

import mixin from "./app/mixin"
import filters from './app/filters';
import './app/scripts';

import VueSnackbar from 'vue-snack'
import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import './assets/elemtor_theme/theme/index.css';
import 'axios-progress-bar/dist/nprogress.css'


Vue.use(VueSnackbar, {})

Vue.use(ElementUI);
// configure language
locale.use(lang)


Vue.config.productionTip = false

Vue.mixin({
    methods: mixin,
    filters
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')